import React, { useState } from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import validator from 'validator';
import { forgotPassword } from "../../../services/AuthService";
import { toast } from "react-toastify";
import Utils from "../../../utils";
import Logo from '../../../assets/Images/Docusafe_logo.webp';
import './AuthPages.css';
import { motion } from 'framer-motion';

function ForgotPassword() {
    const [loading, setLoading] = useState(false);
    const [isLink, setIsLink] = useState(false);
    const [email, setEmail] = useState('');
    let errorsObj = { email: '' };
    const [errors, setErrors] = useState(errorsObj);
    const navigate = useNavigate();

    const onForgot = (e) => {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (email === '') {
            errorObj.email = 'Email is required';
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = 'Please enter valid email address';
            error = true;
        }
        setErrors(errorObj);
        if (error) return;
        setLoading(true);
        let obj = { email: email };
        forgotPassword(obj)
            .then(response => {
                setIsLink(true);
                setLoading(false);
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    };

    return (
        <div className="login-container">
            {loading && <div className="page-loading">
                <img src="/images/loader.gif" alt="loader" />
            </div>}
            {/* Logo at the top */}
            <img src={Logo} alt="Logo" className="login-logo" />
            <div className="login-card">
                <h3 className="login-title">Forgot Password</h3>
                {!isLink ? (
                    <form onSubmit={onForgot}>
                        <div className="mb-3">
                            <motion.label htmlFor="email" className="form-label mb-2" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>Email</motion.label>
                            <input
                                type="email"
                                className="form-control focus:outline-none"
                                id="email"
                                value={email}
                                maxLength="50"
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="user@example.com"
                            />
                            {errors.email && <div className="login-error">{errors.email}</div>}
                        </div>
                        <button type="submit" className="login-btn-page w-100 mb-3">Send Reset Link</button>
                    </form>
                ) : (
                    <div className="success-message">
                        <h4>Check Your Email</h4>
                        <div style={{marginBlock:"10px"}}>
                            We have sent password reset instructions to your email address.
                        </div>
                        <div style={{ color: '#888', fontSize: '0.97rem', marginBottom: '10px !important' }}>
                            If you don't see the email in your inbox, please check your spam folder.
                        </div>
                        <button className="login-btn-page w-100 mb-3" onClick={() => navigate('/login')}>Back to Login</button>
                    </div>
                )}
                {!isLink && (
                    <div className="login-footer">
                        Remember your password? <NavLink to="/login" className="login-link">Back to Login</NavLink>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ForgotPassword;